function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("rect", {
  stroke: "#D3D3D3",
  fill: "#FFF",
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 23,
  rx: 4
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M21.019 6c-1.3 0-2.503.413-3.484 1.112 1.512 1.078 1.512 8.573 0 9.65a5.982 5.982 0 003.484 1.113c3.303 0 5.981-2.658 5.981-5.938C27 8.658 24.322 6 21.019 6",
  fill: "#F59D1E"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M17.465 7.112A5.982 5.982 0 0013.98 6C10.678 6 8 8.658 8 11.937c0 3.28 2.678 5.938 5.981 5.938 1.3 0 2.503-.413 3.484-1.112-1.512-1.078-1.512-8.573 0-9.65",
  fill: "#E91D25"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M19.875 11.937c0-1.957-.937-3.689-2.375-4.75a5.887 5.887 0 00-2.375 4.75c0 1.958.937 3.69 2.375 4.75a5.887 5.887 0 002.375-4.75",
  fill: "#F06122"
}));

var SvgMasterCard = function SvgMasterCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 36 24",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgMasterCard, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/MasterCard.3892e952.svg";
export { ForwardRef as ReactComponent };